// extracted by mini-css-extract-plugin
module.exports = {"layout":"glazial-module--layout--2lO9_"};